import { cn } from '@tempo-io/sui-class-utils';
import { Dependency } from '@tempo-io/sui-icons';
import { bindOpenCardDetailsHandler } from '@/common/components/ui/swimlane/layout/hooks/useCardEventHandlers';
import type { ICellProps } from '@/common/components/ui/swimlane/types';

type ParentTitleProps = ICellProps & {
  id: string;
  title: string;
  backgroundColor?: string;
  className?: string;
};

export const ParentTitle = ({
  id,
  title,
  rowID,
  columnID,
  backgroundColor,
  className,
  ...props
}: ParentTitleProps) => (
  <div
    className={cn(
      'absolute top-0 left-0 right-0 h-6',
      'flex flex-row items-center',
      'px-3 py-1.5 gap-1',
      className,
    )}
    style={{ backgroundColor: backgroundColor || 'var(--color-bg-neutral-subtle)' }}
    {...props}
  >
    <Dependency size={16} className="text-text-neutral-secondary" />
    <button
      type="button"
      className="text-xs text-text-neutral-secondary cursor-pointer truncate border-0 bg-transparent p-0 text-left"
      aria-label="Parent Item"
      {...bindOpenCardDetailsHandler({ itemID: id, rowID, columnID })}
    >
      {title}
    </button>
  </div>
);
